// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p3pp-1nT{color:var(--color-gray-4);flex-wrap:wrap;font-size:max(.75rem,min(.94vw,1.13rem));gap:.25rem;line-height:1.44}.p3pp-1nT,.p3pp-1nT>*{align-items:center;display:flex}.p3pp-1nT>*{gap:max(0rem,min(.21vw,.25rem))}.p3pp-1nT i{font-size:1.11em}@media(max-width:667.98px){.p3pp-1nT i{display:none}}@media(hover:hover){.p3pp-1nT a:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.p3pp-1nT a:active{-webkit-text-decoration:underline;text-decoration:underline}}.p3pp-1nT a.nuxt-link-exact-active{color:var(--color-gray-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"breadcrumbs": "p3pp-1nT"
};
module.exports = ___CSS_LOADER_EXPORT___;
